import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-spo2-sans-o2',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-spo2-sans-o2.component.html',
  styleUrl: './traitement-data-spo2-sans-o2.component.scss',
})
export class TraitementDataSpo2SansO2Component {
  @Input() patient: Patient | undefined;
}
